import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-white-6 workflow_timeline_container",
  style: { padding: 0 }
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "状态：", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" （ ")
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" ） ")
const _hoisted_7 = { class: "buttons_wrapper" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "buttons_wrapper" }
const _hoisted_10 = {
  disabled: true,
  style: {"margin-left":"15px","border":"solid 1px #fd8686"}
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "hw_detail_table_header title_wrapper" }
const _hoisted_14 = {
  class: "title",
  style: {"font-weight":"bold"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "状态：", -1)
const _hoisted_16 = {
  key: 0,
  class: "buttons_wrapper"
}
const _hoisted_17 = {
  id: "mountNode",
  class: "g6_container",
  ref: "mountNode",
  style: {"width":"1200px","height":"700px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_WeHWTimeLine = _resolveComponent("WeHWTimeLine")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_ctx.flow.state_list.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.onlyShowTitle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.titleClick && _ctx.titleClick(...args))),
                  style: {"text-decoration":"none","color":"#333"}
                }, [
                  _hoisted_3,
                  _createElementVNode("span", {
                    style: _normalizeStyle(`color: ${_ctx.flow.current_state.color}; font-weight: bold;`),
                    class: "ml-2"
                  }, _toDisplayString(_ctx.flow.current_state.name), 5),
                  _createElementVNode("span", {
                    style: _normalizeStyle(`${_ctx.flow.current_state.desc_style}`)
                  }, [
                    _hoisted_4,
                    _createElementVNode("span", {
                      innerHTML: _ctx.flow.current_state.state_desc
                    }, null, 8, _hoisted_5),
                    _hoisted_6
                  ], 4)
                ]),
                _createElementVNode("span", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "extra_buttons"),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flow.current_state_actions, (btn, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (btn.condition.disabled)
                        ? (_openBlock(), _createBlock(_component_a_tooltip, {
                            key: 0,
                            title: btn.condition.tip || '请询问管理员'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                disabled: true,
                                type: "primary",
                                style: {"margin-left":"20px","border":"solid 1px #fd8686"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(btn.action_name) + " ", 1),
                                  _createVNode(_component_svg_icon, {
                                    iconName: "QuestionCircleOutlined",
                                    style: {"color":"red","font-size":"16px"}
                                  })
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["title"]))
                        : (_openBlock(), _createBlock(_component_a_button, {
                            key: 1,
                            type: "primary",
                            style: {"margin-left":"20px"},
                            onClick: ($event: any) => (_ctx.changeState(_ctx.flow.current_state, btn))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(btn.action_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                    ], 64))
                  }), 128))
                ])
              ])
            ]))
          : (_ctx.onlyShowButton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _renderSlot(_ctx.$slots, "extra_buttons"),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flow.current_state_actions, (btn, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (btn.condition.disabled)
                        ? (_openBlock(), _createBlock(_component_a_tooltip, {
                            key: 0,
                            title: btn.condition.tip || '请询问管理员'
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", _hoisted_10, [
                                _createTextVNode(_toDisplayString(btn.action_name) + " ", 1),
                                _createVNode(_component_svg_icon, {
                                  iconName: "QuestionCircleOutlined",
                                  style: {"color":"red","font-size":"16px"}
                                })
                              ])
                            ]),
                            _: 2
                          }, 1032, ["title"]))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            style: {"margin-left":"15px"},
                            onClick: ($event: any) => (_ctx.changeState(_ctx.flow.current_state, btn))
                          }, _toDisplayString(btn.action_name), 9, _hoisted_11))
                    ], 64))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("span", {
                      style: _normalizeStyle(`color: ${_ctx.flow.current_state.color}; font-weight: normal;`),
                      class: "ml-2"
                    }, _toDisplayString(_ctx.flow.current_state.name), 5)
                  ]),
                  (!_ctx.hiddenButtons)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                        _renderSlot(_ctx.$slots, "extra_buttons"),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flow.current_state_actions, (btn, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            (btn.condition.disabled)
                              ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                  key: 0,
                                  title: btn.condition.tip || '请询问管理员'
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_button, {
                                      disabled: true,
                                      type: "primary",
                                      style: {"margin-left":"20px"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(btn.action_name) + " ", 1),
                                        _createVNode(_component_svg_icon, {
                                          iconName: "QuestionCircleOutlined",
                                          style: {"color":"red","font-size":"16px"}
                                        })
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["title"]))
                              : (_openBlock(), _createBlock(_component_a_button, {
                                  key: 1,
                                  type: "primary",
                                  style: {"margin-left":"20px"},
                                  onClick: ($event: any) => (_ctx.changeState(_ctx.flow.current_state, btn))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(btn.action_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                          ], 64))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_WeHWTimeLine, _mergeProps({
                  entityType: "flow",
                  entity: _ctx.flow,
                  onAfterEditEntity: _ctx.onUpdate
                }, _ctx.$attrs), null, 16, ["entity", "onAfterEditEntity"]),
                _createVNode(_component_a_modal, {
                  visible: _ctx.workFlowVisible,
                  "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.workFlowVisible) = $event)),
                  centered: "",
                  footer: null,
                  width: "1240px"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, null, 512)
                  ]),
                  _: 1
                }, 8, ["visible"])
              ])),
        _createVNode(_component_a_modal, {
          visible: _ctx.showOldStates,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showOldStates) = $event)),
          centered: "",
          footer: null,
          width: "1240px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_WeHWTimeLine, _mergeProps({
              entityType: "flow",
              entity: _ctx.flow,
              onAfterEditEntity: _ctx.onUpdate
            }, _ctx.$attrs), null, 16, ["entity", "onAfterEditEntity"])
          ]),
          _: 1
        }, 8, ["visible"])
      ]))
    : _createCommentVNode("", true)
}